import React from 'react';
import { FadeIn } from './FadeIn';
import { X } from 'lucide-react';
export function WhyItDidntWork() {
  const reasons = ['Intentar «investigar» cada detalle sexual esperando que la verdad te dé paz (solo te genera más imágenes traumáticas).', 'Contárselo a amigos o familiares que te juzgan y te presionan para que tomes una decisión rápida.', 'Esperar a que el tiempo «lo cure todo» sin cambiar la estructura que permitió el engaño en primer lugar.', 'Creer que si eres «mejor pareja» a partir de ahora, la otra persona no volverá a fallar (la culpa no es tuya).'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-brand-dark" data-id="element-243">
      <div className="max-w-3xl mx-auto" data-id="element-244">
        <FadeIn data-id="element-245">
          <h2 className="text-3xl sm:text-4xl font-serif text-brand-amber mb-12 text-center" data-id="element-246">
            Lo que ya intentaste (y por qué no funcionó)
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-247">
          {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-248">
              <div className="flex items-start gap-4 p-6 rounded-lg bg-[#1a1a1a] border border-white/5" data-id="element-249">
                <div className="flex-shrink-0 mt-1" data-id="element-250">
                  <div className="w-8 h-8 rounded-full bg-red-900/30 flex items-center justify-center" data-id="element-251">
                    <X className="w-5 h-5 text-red-500" data-id="element-252" />
                  </div>
                </div>
                <p className="text-brand-offwhite/80 leading-relaxed" data-id="element-253">
                  {reason}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}